import { ChangeDetectorRef, Component, Injector } from '@angular/core';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { FeaturesService } from 'src/app/Services/features.service';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { UntypedFormArray, Validators } from '@angular/forms';

@Component({
    selector: 'app-edithotelreservationpermittype',
    templateUrl: './edithotelreservationpermittype.component.html',
    styleUrls: ['./edithotelreservationpermittype.component.scss'],
    standalone: false
})
export class EdithotelreservationpermittypeComponent extends ModelEditor {
  public ParkingLots: any[] = [];
  public EndUserRoles: any[] = [];
  public SpaceTypes: any[] = [];
  public CustomerGroups: any[] = [];
  public CustomerGroupsAvailable: boolean = false;

  constructor(
    private apiService: ApiServiceBase,
    private injector: Injector,
    organizationService: OrganizationsService,
    modalService: SimpleModalService,
    toastService: ToastrService,
    private cdRef: ChangeDetectorRef,
    private featuresService: FeaturesService,
    private permissionsService: PermissionsService
  ) {
    super("permits/hotelreservationpermittypes", injector);
    // match standard editor behaviour for optional customer groups
    this.checkCustomerGroupsAccess();
  }

  private async checkCustomerGroupsAccess() {
    try {
      const featureEnabled = await this.featuresService.FeatureEnabled('FrogOne.Common.Features.Parking.CustomerGroupsFeature');
      if (!featureEnabled) {
        this.CustomerGroupsAvailable = false;
        return;
      }
      const hasPermission = await this.permissionsService.CheckAdminPermission('FrogOne.Common.Features.Parking.CustomerGroupsFeature', 100);
      if (!hasPermission) {
        this.CustomerGroupsAvailable = false;
        return;
      }
      this.CustomerGroups = await this.apiService.Get<any>("parking/customergroups");
      this.CustomerGroupsAvailable = true;
    } catch {
      this.CustomerGroupsAvailable = false;
    }
  }

  public override DefaultModel(): any {
    return {
      Name: null,
      ClassName: "HotelReservationParkingPermitType",
      HelpUrl: null,
      HelpLinkText: null,
      UniqueCode: null,
      ActiveStartDateLocal: null,
      ActiveEndDateLocal: null,
      RestrictToUserRoles: false,
      RestrictTimesOfDay: false,
      RestrictBySpaceType: false,
      RequireRegisteredVehicles: false,
      VehicleModificationTimeout: null,
      MaxVehicles: null,
      PurchasingOption: 0,
      LimitToParkingSpace: false,
      MaxActivePermits: null,
      CutoffTimeLocal: null,
      RequiresApproval: false,
      // One-time payment schedule (matches Standard Permit Types "Once" schedule format)
      PaymentSchedule: '101|1|-1|-1|-1|0|F|F|0',
      ParkingStructures: [],
      RoleRestrictions: [],
      Prices: [],
      TimeRestrictions: [],
      SpaceTypeRestrictions: [],
      MutualExclusions: []
    };
  }

  public override AfterModelLoaded(): void {
    // Convert datetime strings to date-only format for date inputs (Angular date input expects YYYY-MM-DD)
    this.stripTimeFromDate('ActiveStartDateLocal');
    this.stripTimeFromDate('ActiveEndDateLocal');

    const pricesArray = this.FormArray(this.Form, 'Prices');
    pricesArray.controls.forEach((control: any) => {
      const effectiveDateControl = control.get?.('EffectiveStartDateLocal') ?? control.get('EffectiveStartDateLocal');
      if (effectiveDateControl?.value) {
        const dateValue = effectiveDateControl.value;
        if (typeof dateValue === 'string' && dateValue.includes('T')) {
          effectiveDateControl.setValue(dateValue.split('T')[0], { emitEvent: false });
        }
      }
    });
  }

  private stripTimeFromDate(name: string) {
    const formControl = this.Form.get(name);
    if (formControl?.value) {
      const dateValue = formControl.value;
      if (typeof dateValue === 'string' && dateValue.includes('T')) {
        formControl.setValue(dateValue.split('T')[0], { emitEvent: false });
      }
    }
  }

  public override BeforeSave(): boolean | void {
    // allow save
    return true;
  }

  public override Validators(): any {
    // IMPORTANT: ModelEditor expects Angular ValidatorFn's (or arrays of them), not { required: true } objects.
    return {
      'Name': [Validators.required],
      'UniqueCode': [Validators.maxLength(128)],
      'ActiveStartDateLocal': [Validators.required],
      'ActiveEndDateLocal': [Validators.required],
      'MaxActivePermits': [Validators.min(0)],
      'MaxVehicles': [Validators.min(0)],
      'VehicleModificationTimeout': [Validators.min(0)],
      'HelpUrl': [Validators.maxLength(2048), Validators.pattern(/^https?:\/\/.+/i)],
      'HelpLinkText': [Validators.maxLength(128)],
    };
  }

  public OnUniqueCodeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const upper = input.value.toUpperCase();
    if (input.value !== upper) {
      this.Form.get('UniqueCode')?.setValue(upper);
    }
  }

  public get PricesArray(): UntypedFormArray {
    return this.FormArray(this.Form, "Prices");
  }

  public AddPrice() {
    let u = { Id: null, Price: 0, EffectiveStartDateLocal: null, PaymentPeriod: 0 };
    this.AddToFormArray(this.FormArray(this.Form, 'Prices'), u, "Prices");
  }

  public RemovePrice(index: any) {
    this.FormArray(this.Form, "Prices").removeAt(index);
    this.Form.markAsDirty();
  }
}


